import WithNavBar from '../../Layouts/WithNavBar';
import { Container } from 'react-bootstrap';
import { MdArrowBackIosNew } from 'react-icons/md';
import { Text, View } from '@aws-amplify/ui-react';
import ButtonCTA from '../../components/ButtonCTA';
import CustomCard from '../../components/CustomCard';
import { BsQuestionCircleFill } from 'react-icons/bs';
import QuestionDifficulty from '../../components/QuestionDifficulty';
import QuestionAnswer from '../../components/QuestionAnswer';
import CustomInput from '../../components/CustomInput';
import CustomDropDown from '../../components/CustomDropDown';
import { TiArrowUnsorted } from 'react-icons/ti';
import CustomFooter from '../../components/CustomFooter';
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomTopbar from '../../components/CustomTopbar';
import CustomMenubar from '../../components/CustomMenubar';
import * as Actions from '../../store/actions';
import { Images, ReactTable } from '../../components';
import Moment from 'react-moment';
import ProgressBar from 'react-bootstrap/ProgressBar';
import * as TYPES from '../../store/actions/actions.js';
import './style.sass';
import Table from '../../components/Tabls';
import { HiSparkles } from 'react-icons/hi2';

import {
  feedbackNotTaken,
  feedbackNotUnderstand,
  feedbackUnderstand,
} from '../../components/Images';

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [quizFinish, setQuizFinish] = useState({});
  const [quizId, setQuizId] = useState('');
  const [answerFilter, setAnswerFilter] = useState('');
  const [difficultyFilter, setDifficultyFilter] = useState('');
  const [topicsFilter, setTopicsFilter] = useState('');
  const [topicsFilterOptions, setTopicsFilterOptions] = useState([]);
  const [filteredResult, setFilteredResult] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [userQuizSections, setUserQuizSections] = useState([]);
  const [selectedQuizSection, setSelectedQuizSection] = useState('');
  const [selectedQuizSectionName, setSelectedQuizSectionName] = useState('');
  const [sectionTotal, setSectionTotal] = useState(0);
  const [sectionCorrect, setSectionCorrect] = useState(0);
  const [sectionIncorrect, setSectionIncorrect] = useState(0);
  const [sectionOmitted, setSectionOmitted] = useState(0);
  const [selectedQuiz, setSelectedQuiz] = useState({});
  const [assignmentTrackerReviewed, setAssignmentTrackerReviewed] = useState(0);
  const [assignmentTrackerTotal, setAssignmentTrackerTotal] = useState(0);
  const [quizName, setQuizName] = useState('');
  const [quizSectionName, setQuizSectionName] = useState('');
  const [quizSectionQuestionsNumber, setQuizSectionQuestionsNumber] = useState(0);
  const [quizResponse, setQuizResponse] = useState({});
  const [showReviewHint, setShowReviewHint] = useState(false);
  const prevQuizIdRef = useRef('');

  const [
    quizFinishedState,
    quizFinishedId,
    hsptReloadRequired,
    studentSelectedSectionBeforeReview,
    isLoading,
  ] = useSelector((state) => {
    return [
      state.finishUserQuiz.quizFinishedData,
      state.finishUserQuiz.quizFinishedId,
      state.helper.hsptReloadRequired,
      state.dashboard.studentSelectedSectionBeforeReview,
      state.helper.isLoading,
    ];
  });

  const [cognitoUser, userDetails] = useSelector((state) => [
    state.auth.cognito,
    state.auth.user,
  ]);

  // 非学生角色（教师/管理员等）直接可见 topic，不需要完成 review 解锁
  const userRole = userDetails?.userType || cognitoUser?.profile;
  const isNonStudent = !!userRole && userRole !== 'STUDENT';

  useEffect(() => {
    setQuizResponse(quizFinishedState);
    setQuizName(selectedQuiz?.quiz?.alias ? selectedQuiz?.quiz?.alias : selectedQuiz?.quiz?.title);
    var temp = [];
    quizFinishedState?.userAnswer?.map((item) => {
      var parsedItem = JSON.parse(item);
      const tempReview = quizFinishedState?.userQuizAnswers?.items?.find(
        (o) => o.questionId == parsedItem?.questionId,
      );
      parsedItem['review'] = tempReview;

      // --- Start of the fix: Override with actual answer and time if review exists ---
      if (tempReview) {
        parsedItem.answer = tempReview.answer;
        parsedItem.time = tempReview.time;
        // Optionally recompute or adjust 'correct' if needed, but it's likely server-set and should remain as-is
      }
      // --- End of the fix ---

      temp.push(parsedItem);
    });
    setQuizFinish(temp);
    setUserQuizSections(quizFinishedState?.sections);
    setSelectedQuiz(quizFinishedState);
    if (searchParams && quizFinishedState) {
      if (searchParams.get('source')) {
        if (searchParams.get('source') == 'dashboard') {
          const filteredSectionAnswers = temp.filter((item2) => {
            return item2['sectionId'] === quizFinishedState?.sections[0]?.id;
          });

          setFilteredResult(filteredSectionAnswers);

          setSelectedQuizSection(quizFinishedState?.sections?.[0]?.id);
          setSelectedQuizSectionName(quizFinishedState?.sections?.[0]?.title);
        } else if (
          searchParams.get('source') == 'review' &&
          studentSelectedSectionBeforeReview?.sectionId
        ) {
          console.log('I am inside review');
          const index = quizFinishedState?.sections?.findIndex(
            (x) => x.id === studentSelectedSectionBeforeReview?.sectionId,
          );
          console.log('Index is ', index);
          if (index !== -1) {
            const filteredSectionAnswers = temp.filter((item2) => {
              return item2['sectionId'] === quizFinishedState?.sections[index]?.id;
            });

            setFilteredResult(filteredSectionAnswers);

            setSelectedQuizSection(quizFinishedState?.sections[index]?.id);
            setSelectedQuizSectionName(quizFinishedState?.sections[index]?.title);
          } else {
            const filteredSectionAnswers = temp.filter((item2) => {
              return item2['sectionId'] === quizFinishedState?.sections[0]?.id;
            });

            setFilteredResult(filteredSectionAnswers);

            setSelectedQuizSection(quizFinishedState?.sections?.[0]?.id);
            setSelectedQuizSectionName(quizFinishedState?.sections?.[0]?.title);
          }
          console.log('Checkout param exists ', searchParams.get('source'));
        }
      } else {
        const filteredSectionAnswers = temp.filter((item2) => {
          return item2['sectionId'] === quizFinishedState?.sections[0]?.id;
        });

        setFilteredResult(filteredSectionAnswers);

        setSelectedQuizSection(quizFinishedState?.sections?.[0]?.id);
        setSelectedQuizSectionName(quizFinishedState?.sections?.[0]?.title);
      }
    }
  }, [searchParams, quizFinishedState, studentSelectedSectionBeforeReview]);

  useEffect(() => {
    dispatch({
      type: TYPES.LOADER_TEXT,
      data: '',
    });
    dispatch(Actions.resetReviewReducer({}));
    if (window?.location?.href?.includes('tab=')) {
      setTimeout(() => {
        navigate('/dashboard');
        window?.location?.reload();
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (hsptReloadRequired === false) {
      dispatch(Actions.hsptNeedsReload(true));
    }
  }, [hsptReloadRequired]);

  const options1 = [
    {
      text: 'All',
      value: '',
    },
    {
      text: 'Correct',
      value: 'TRUE',
    },
    {
      text: 'Wrong',
      value: 'FALSE',
    },
  ];

  const options2 = [
    {
      text: 'All',
      value: '',
    },
    {
      text: 'Easy',
      value: 'Easy',
    },
    {
      text: 'Medium',
      value: 'Medium',
    },
    {
      text: 'Hard',
      value: 'Hard',
    },
  ];

  useEffect(() => {}, [sectionTotal, sectionCorrect, sectionIncorrect, sectionOmitted]);

  // save started quiz data to usestate
  // useEffect(() => {
  //   if (quizFinishedState) {
  //     // console.log("Quiz finish state ", quizFinishedState);
  //     setQuizName(
  //       selectedQuiz?.quiz?.alias
  //         ? selectedQuiz?.quiz?.alias
  //         : selectedQuiz?.quiz?.title
  //     );
  //     var tempTopics = [
  //       {
  //         text: "All",
  //         value: "",
  //       },
  //     ];
  //     // const allSections = [
  //     //   ...new Set(quizFinishedState?.sections?.map((item) => item?.title)),
  //     // ];
  //     const unique = [
  //       ...new Set(
  //         quizFinishedState?.userAnswer?.map((item) => {
  //           if (
  //             JSON.parse(item)?.sectionId === quizFinishedState?.sections[0]?.id
  //           ) {
  //             // console.log(JSON.parse(item)?.topic);
  //             return JSON.parse(item)?.topic;
  //           }
  //           return null; // Add a default return value here
  //         })
  //       ),
  //     ];
  //     const topicUniques = unique.filter((value) => value !== null);
  //     topicUniques?.map((item) => {
  //       tempTopics.push({
  //         text: item,
  //         value: item,
  //       });
  //     });
  //     // setTopicsFilter(tempTopics);
  //     setTopicsFilterOptions(tempTopics);
  //     var temp = [];
  //     quizFinishedState?.userAnswer?.map((item) => {
  //       var parsedItem = JSON.parse(item);
  //       const tempReview = quizFinishedState?.userQuizAnswers?.items?.find(
  //         (o) => o.questionId == parsedItem?.questionId
  //       );
  //       parsedItem["review"] = tempReview;
  //       temp.push(parsedItem);
  //     });
  //     const filteredSectionAnswers = temp.filter((item2) => {
  //       return item2["sectionId"] === quizFinishedState?.sections[0]?.id;
  //     });
  //     setQuizFinish(temp);
  //     setFilteredResult(filteredSectionAnswers);
  //     setUserQuizSections(quizFinishedState?.sections);
  //     setSelectedQuizSection(quizFinishedState?.sections?.[0]?.id);
  //     setSelectedQuizSectionName(quizFinishedState?.sections?.[0]?.title);
  //     setSelectedQuiz(quizFinishedState);
  //   }
  // }, [quizFinishedState]);

  useEffect(() => {
    if (quizFinishedId) {
      setQuizId(quizFinishedId);
    }
  }, [quizFinishedId]);

  useEffect(() => {
    if (quizId !== '') {
      dispatch(Actions.dispatchGetQuizScores(quizId));
    }
  }, [quizId]);

  // handling
  const onFilterChange = (e) => {
    if (e.target.name === 'answer') {
      setAnswerFilter(e.target.value);
      var selectedOptions = [
        {
          filter: false,
          key: 'correct',
          value: e.target.value,
        },
        {
          filter: false,
          key: 'difficulty',
          value: difficultyFilter,
        },
        {
          filter: false,
          key: 'topic',
          value: topicsFilter,
        },
      ];
      if (e.target.value !== '') {
        selectedOptions[0].filter = true;
      }
      if (difficultyFilter !== '') {
        selectedOptions[1].filter = true;
      }
      if (topicsFilter !== '') {
        selectedOptions[2].filter = true;
      }
      // var fil = quizFinish;
      var fil = quizFinish.filter((item2) => {
        return item2['sectionId'] === selectedQuizSection;
      });
      selectedOptions.map((item) => {
        if (item.filter) {
          fil = fil.filter((item2) => {
            return item2[`${item.key}`] === item.value;
          });
        }
      });
      setFilteredResult(fil);
    } else if (e.target.name === 'difficulty') {
      setDifficultyFilter(e.target.value);
      var selectedOptions = [
        {
          filter: false,
          key: 'correct',
          value: answerFilter,
        },
        {
          filter: false,
          key: 'difficulty',
          value: e.target.value,
        },
        {
          filter: false,
          key: 'topic',
          value: topicsFilter,
        },
      ];
      if (answerFilter !== '') {
        selectedOptions[0].filter = true;
      }
      if (e.target.value !== '') {
        selectedOptions[1].filter = true;
      }
      if (topicsFilter !== '') {
        selectedOptions[2].filter = true;
      }
      // var fil = quizFinish;
      var fil = quizFinish.filter((item2) => {
        return item2['sectionId'] === selectedQuizSection;
      });
      selectedOptions.map((item) => {
        if (item.filter) {
          fil = fil.filter((item2) => {
            return item2[`${item.key}`] === item.value;
          });
        }
      });
      setFilteredResult(fil);
    } else if (e.target.name === 'topic') {
      setTopicsFilter(e.target.value);
      var selectedOptions = [
        {
          filter: false,
          key: 'correct',
          value: answerFilter,
        },
        {
          filter: false,
          key: 'difficulty',
          value: difficultyFilter,
        },
        {
          filter: false,
          key: 'topic',
          value: e.target.value,
        },
      ];
      if (answerFilter !== '') {
        selectedOptions[0].filter = true;
      }
      if (difficultyFilter !== '') {
        selectedOptions[1].filter = true;
      }
      if (e.target.value !== '') {
        selectedOptions[2].filter = true;
      }
      // var fil = quizFinish;
      var fil = quizFinish.filter((item2) => {
        return item2['sectionId'] === selectedQuizSection;
      });
      selectedOptions.map((item) => {
        if (item.filter) {
          fil = fil.filter((item2) => {
            return item2[`${item.key}`] === item.value;
          });
        }
      });
      setFilteredResult(fil);
    }
  };

  function RenderAnswer(actualAnswer) {
    try {
      var answer = JSON.parse(actualAnswer);
      var text = '';
      switch (answer[0]) {
        case 'MATCH':
          for (var i = 1; i < answer.length; i++) {
            if (i === 1) {
              text += answer[i];
            } else {
              text += ' OR ' + answer[i];
            }
          }
          break;

        case 'RANGE':
          text = 'Answer should be between ' + answer[1] + ' - ' + answer[2];
          break;

        default:
          break;
        // code
      }
      return text;
    } catch (err) {
      console.log('CheckSPRAnswer failed catch');
      return false;
    }
  }

  // let data = [];
  // useEffect(() => {
  //   data = [];
  //   if (filteredResult) {
  //     filteredResult.map((item, key) => {
  //       data.push({
  //         question: key + 1,
  //         yourAnswer: (
  //           <div className="d-flex justify-content-center">
  //             <span className={"answer-icon"}>{item.answer}</span>
  //           </div>
  //         ),
  //         correctAnswer: (
  //           <QuestionAnswer
  //             answer={
  //               item.answer == "skip"
  //                 ? "review"
  //                 : item.correct === "TRUE"
  //                 ? "correct"
  //                 : "review"
  //             }
  //             userQuizId={""}
  //             questionId={item?.questionId}
  //             userAnswer={item.answer}
  //           />
  //         ),
  //         time: new Date(item.time * 1000).toISOString().substr(14, 5),
  //         difficulty: <QuestionDifficulty level={item.difficulty} />,
  //         questionTopic: item.topic,
  //         questionSubTopic: item.subtopic,
  //       });
  //     });
  //     setTableData(data);
  //   }
  // }, [filteredResult]);

  let data = [];
  useEffect(() => {
    data = [];
    if (filteredResult) {
      var reviewObj = {};
      filteredResult.map((item, key) => {
        // console.log("item", item);
        var isReviewFinished = false;
        if (
          item?.review?.reviewFeedback === 'FINISHED' ||
          item?.review?.reviewFeedback === 'FLAGGED'
        ) {
          reviewObj = JSON.parse(item?.review?.review);
          isReviewFinished = true;
        }
        var myCorrectAnswer = '';

        if (item?.review?.reviewFeedback == null) {
          if (item?.correct === 'TRUE') {
            myCorrectAnswer = 'correct';
          } else if (item?.correct === 'FALSE') {
            myCorrectAnswer = 'review';
          }
        } else if (item?.review?.reviewFeedback != null) {
          if (item?.correct === 'TRUE') {
            myCorrectAnswer = 'correct';
          } else if (item?.answer === 'Skip') {
            if (
              item?.review?.reviewFeedback === 'FINISHED' ||
              item?.review?.reviewFeedback === 'FLAGGED'
            ) {
              myCorrectAnswer = 'skipped';
            } else {
              myCorrectAnswer = 'review';
            }
          } else if (item?.correct === 'FALSE') {
            myCorrectAnswer = 'incorrect';
          }
        }

        data.push({
          question: item.orderId,
          yourAnswer: (
            <div className="d-flex justify-content-center">
              <span
                className={
                  item.answer == 'Skip'
                    ? 'skip-ans'
                    : item.correct === 'FALSE'
                    ? 'answer-icon-skip-incorrect'
                    : 'answer-icon'
                }
              >
                {item.answer.toUpperCase()}
              </span>{' '}
            </div>
          ),
          correctAnswer: (
            <>
              {quizResponse?.quiz?.type === 'SAT' || quizResponse?.quiz?.type === 'DSAT' ? (
                <QuestionAnswer
                  answer={myCorrectAnswer}
                  userQuizId={quizFinishedState?.id}
                  questionId={item?.questionId}
                  userAnswer={item?.answer}
                  isReviewNew={item?.review === undefined ? true : false}
                  topicId={item?.topicId}
                  topic={item?.topic}
                  subtopic={item?.subtopic}
                  subtopicId={item?.subtopicId}
                  isReviewFinished={isReviewFinished}
                  correctAnswer={
                    item?.correctAnswer?.includes('MATCH' || 'RANGE')
                      ? RenderAnswer(item?.correctAnswer)
                      : item?.correctAnswer
                  }
                  feedbackStatus={
                    item?.review?.reviewFeedback ? item?.review?.reviewFeedback : null
                  }
                  reviewObj={reviewObj}
                  type="correctAnswer"
                  selectedQuizSection={selectedQuizSection}
                />
              ) : (
                <>
                  {myCorrectAnswer === 'correct' ? (
                    <>
                      <div className="answer-col">
                        <img src={Images.correct} alt="correct" style={{ cursor: 'pointer' }} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="text-incorrect">{item.correctAnswer}</div>
                    </>
                  )}
                </>
              )}
            </>
          ),
          time: new Date(item.time * 1000).toISOString().substr(14, 5),
          difficulty: <QuestionDifficulty level={item.difficulty} />,
          questionTopic:
            item.correct === 'TRUE' || isNonStudent || !shouldShowReviewFeatures() ? (
              item.topic
            ) : (
              <>
                {item?.review?.reviewFeedback === null ||
                item?.review === undefined ||
                item?.review?.reviewFeedback === 'PENDING' ? (
                  <QuestionAnswer
                    answer={'review'}
                    userQuizId={quizFinishedState?.id}
                    questionId={item?.questionId}
                    userAnswer={item?.answer}
                    isReviewNew={item?.review === undefined ? true : false}
                    topicId={item?.topicId}
                    topic={item?.topic}
                    subtopic={item?.subtopic}
                    subtopicId={item?.subtopicId}
                    isReviewFinished={isReviewFinished}
                    correctAnswer={item?.correctAnswer}
                    feedbackStatus={
                      item?.review?.reviewFeedback ? item?.review?.reviewFeedback : null
                    }
                    reviewObj={reviewObj}
                    type="questionTopic"
                    selectedQuizSection={selectedQuizSection}
                  />
                ) : (
                  item.topic
                )}
              </>
            ),
          questionSubTopic:
            item.correct === 'TRUE' || isNonStudent || !shouldShowReviewFeatures() ? (
              item.subtopic
            ) : (
              <>
                {item?.review?.reviewFeedback === null ||
                item?.review === undefined ||
                item?.review?.reviewFeedback === 'PENDING' ? (
                  <QuestionAnswer
                    answer={'review'}
                    userQuizId={quizFinishedState?.id}
                    questionId={item?.questionId}
                    userAnswer={item?.answer}
                    isReviewNew={item?.review === undefined ? true : false}
                    topicId={item?.topicId}
                    topic={item?.topic}
                    subtopic={item?.subtopic}
                    subtopicId={item?.subtopicId}
                    isReviewFinished={isReviewFinished}
                    correctAnswer={item?.correctAnswer}
                    feedbackStatus={
                      item?.review?.reviewFeedback ? item?.review?.reviewFeedback : null
                    }
                    reviewObj={reviewObj}
                    type="questionSubTopic"
                    selectedQuizSection={selectedQuizSection}
                  />
                ) : (
                  item.subtopic
                )}
              </>
            ),
          feedback: (
            <>
              <img
                alt={
                  item?.review?.reviewFeedback == null
                    ? item?.correct === 'TRUE'
                      ? 'not-taken-yet'
                      : 'not-taken-yet'
                    : item?.review?.reviewFeedback === 'PENDING'
                    ? 'not-taken-yet'
                    : item?.review?.reviewFeedback === 'FINISHED'
                    ? 'green-thumb'
                    : item?.review?.reviewFeedback === 'FLAGGED'
                    ? 'red-hand'
                    : 'not-taken-yet'
                }
                src={
                  item?.review?.reviewFeedback == null
                    ? item?.correct === 'TRUE'
                      ? feedbackNotTaken
                      : feedbackNotTaken
                    : item?.review?.reviewFeedback === 'PENDING'
                    ? feedbackNotTaken
                    : item?.review?.reviewFeedback === 'FINISHED'
                    ? feedbackUnderstand
                    : item?.review?.reviewFeedback === 'FLAGGED'
                    ? feedbackNotUnderstand
                    : feedbackNotTaken
                }
              />
            </>
          ),
        });
      });

      setTableData(data);
    }
  }, [filteredResult]);

  useEffect(() => {
    if (selectedQuizSection) {
      setAnswerFilter('');
      setDifficultyFilter('');
      setTopicsFilter('');
      const filteredSectionAnswers = quizFinish.filter((item2) => {
        return item2['sectionId'] === selectedQuizSection;
      });
      var tempCorrect = 0;
      var tempIncorrect = 0;
      var tempOmitted = 0;
      var assignmentTotal = 0;
      var assignmentReviewed = 0;
      filteredSectionAnswers?.map((item) => {
        if (item?.answer === 'skip') {
          tempOmitted++;
          tempIncorrect++;
          assignmentTotal++;
        } else if (item.correct === 'TRUE') {
          tempCorrect++;
        } else if (item.correct === 'FALSE') {
          assignmentTotal++;
          tempIncorrect++;
        }
        if (
          item?.correct === 'FALSE' &&
          (item?.review?.reviewFeedback === 'FINISHED' ||
            item?.review?.reviewFeedback === 'FLAGGED')
        ) {
          assignmentReviewed++;
        }
      });
      setAssignmentTrackerReviewed(assignmentReviewed);
      setAssignmentTrackerTotal(assignmentTotal);
      setSectionTotal(filteredSectionAnswers?.length);
      setSectionCorrect(tempCorrect);
      setSectionIncorrect(tempIncorrect);
      setSectionOmitted(tempOmitted);
      setFilteredResult(filteredSectionAnswers);

      var tempTopics = [
        {
          text: 'All',
          value: '',
        },
      ];
      // const allSections = [
      //   ...new Set(quizFinishedState?.sections?.map((item) => item?.title)),
      // ];
      const unique = [
        ...new Set(
          quizFinishedState?.userAnswer?.map((item) => {
            if (JSON.parse(item)?.sectionId === selectedQuizSection) {
              return JSON.parse(item)?.topic;
            }
            return null; // Add a default return value here
          }),
        ),
      ];
      const topicUniques = unique.filter((value) => value !== null);
      topicUniques?.map((item) => {
        tempTopics.push({
          text: item,
          value: item,
        });
      });
      // setTopicsFilter(tempTopics);
      setTopicsFilterOptions(tempTopics);
    }
  }, [selectedQuizSection, quizFinish, isNonStudent]);

  const onClearFilters = () => {
    setAnswerFilter('');
    setDifficultyFilter('');
    setTopicsFilter('');
    const filteredSectionAnswers = quizFinish.filter((item2) => {
      return item2['sectionId'] === selectedQuizSection;
    });
    setFilteredResult(filteredSectionAnswers);
  };

  /**
   * 判断是否应该显示 review 相关功能
   * 对于 HSPT 类型的考试，不显示 review tips 和 review 按钮
   * @returns {boolean} 如果应该显示 review 功能返回 true，否则返回 false
   */
  const shouldShowReviewFeatures = () => {
    // 只有在类型确定且不是 HSPT 时才返回 true
    return quizResponse?.quiz?.type && quizResponse?.quiz?.type !== 'HSPT';
  };

  // 检查是否应该显示提示（需要等待 dispatchGetQuizScores 请求完成后再检查）
  useEffect(() => {
    // 如果 quizId 变化了，立即重置 hint，避免显示旧数据的 hint
    if (prevQuizIdRef.current !== quizId) {
      prevQuizIdRef.current = quizId;
      setShowReviewHint(false);
      // 如果 quizId 变为空，直接返回
      if (quizId === '') {
        return;
      }
    }

    // 检查请求是否已完成：
    // 1. quizId 存在（说明请求已发起）
    // 2. isLoading 为 false（说明请求已完成）
    // 3. quizFinishedState 不是空数组（初始值是 []）
    // 4. quizFinishedState 是一个对象
    // 5. quizFinishedState.id 与 quizId 匹配（确保是当前请求的数据）
    // 6. quizFinishedState.quiz 存在
    // 7. quizFinishedState.quiz.type 存在
    const isRequestCompleted = 
      quizId !== '' &&
      isLoading === false &&
      quizFinishedState && 
      Array.isArray(quizFinishedState) === false && 
      typeof quizFinishedState === 'object' &&
      quizFinishedState.id === quizId &&
      quizFinishedState.quiz &&
      quizFinishedState.quiz.type;

    // 如果请求还没有完成或数据还没有完整加载，不显示 hint
    if (!isRequestCompleted) {
      return;
    }

    // 只有当请求完成且数据完整加载时，才检查是否显示 hint
    const hintDismissed = localStorage.getItem('reviewHintDismissed');
    // 只有在未关闭过且应该显示 review 功能时才显示 hint
    // 对于 HSPT 类型，不显示 hint
    if (!hintDismissed && quizFinishedState.quiz.type !== 'HSPT') {
      setShowReviewHint(true);
    } else {
      setShowReviewHint(false);
    }
  }, [quizId, isLoading, quizFinishedState]);

  return (
    <WithNavBar IsLoggedIn={true}>
      <CustomTopbar
        name={selectedQuiz?.quiz?.alias ? selectedQuiz?.quiz?.alias : selectedQuiz?.quiz?.title}
        finishedAt={selectedQuiz?.finishedAt}
        quizType={quizFinishedState?.quiz?.type || selectedQuiz?.quiz?.type}
      />
      <CustomMenubar active={'questions'} quizType={selectedQuiz?.quiz?.type} />
      <Container className={'dashboard-div'}>
        <div className="content">
          <ul className="nav nav-tabs pb-4 section-tabs">
            {userQuizSections?.map((item, key) => {
              return (
                <li key={key} className="nav-item">
                  <button
                    className={`nav-link ${selectedQuizSection == item?.id ? 'active' : ''}`}
                    onClick={() => {
                      setSelectedQuizSection(item?.id);
                      setSelectedQuizSectionName(item?.title);
                    }}
                  >
                    {item?.title}
                  </button>
                </li>
              );
            })}
          </ul>
          <div className="content-header">
            Questions Overview <BsQuestionCircleFill />
          </div>
          <div className="content-body">
            <div className="tab-content">
              {userQuizSections?.map((item, key) => {
                return (
                  <div
                    key={key}
                    className={`tab-pane fade ${
                      selectedQuizSection == item?.id ? 'show active' : ''
                    }`}
                  >
                    <div className="inner-cards">
                      <div className="cards-row">
                        <CustomCard title={sectionTotal} description={'Total Questions'} />
                        <CustomCard title={sectionCorrect} description={'Correct Answers'} />
                        <CustomCard title={sectionIncorrect} description={'Incorrect Answers'} />
                        <CustomCard title={sectionOmitted} description={'Omitted Answers'} />
                      </div>
                      <div className="test-key-row">
                        <div className="test-key-row-left">
                          <h4>Test Questions key</h4>
                          <div className="question-keys">
                            <div className="difficulty-levels">
                              <QuestionDifficulty level="Easy" showText={true} />
                              <QuestionDifficulty level="Medium" showText={true} />
                              <QuestionDifficulty level="Hard" showText={true} />
                            </div>
                            <div className="answer-levels">
                              <QuestionAnswer answer="correct" showText={true} type="icon" />
                              <QuestionAnswer answer="incorrect" showText={true} type="icon" />
                              <QuestionAnswer answer="skipped" showText={true} type="icon" />
                            </div>
                          </div>
                        </div>
                        <div className="test-key-row-right">
                          <ButtonCTA
                            className={'consultation-button-emphatic icon-right'}
                            label={'Feeling stuck? Talk to an instructor!'}
                            onClick={() =>
                              window.open(
                                'https://app.acuityscheduling.com/schedule/cbb8829e/appointment/18531396/calendar/5341132?categories%5B%5D=Consultation',
                                '_blank',
                                'noopener,noreferrer',
                              )
                            }
                            padding="18px 22px"
                            fontSize="16px"
                            height="52px"
                            lightBlue
                            icon={<HiSparkles />}
                          />
                        </div>
                      </div>
                      {/* <h5 style={{ marginLeft: "30px", marginTop: "40px" }}>
                        Read Test Questions
                      </h5>
                      <Text
                        className="text-secondary"
                        style={{
                          marginLeft: "30px",
                          marginTop: "10px",
                          marginBottom: "30px",
                        }}
                      >
                        The questions in your score report may not be in same
                        order as you saw on test day
                      </Text> */}
                    </div>

                    <div className="filter-row">
                      <div className={'filter-col'}>
                        <CustomDropDown
                          label="Response"
                          name={'answer'}
                          onFilterChange={onFilterChange}
                          options={options1}
                          value={answerFilter}
                        />
                      </div>
                      {quizResponse?.quiz?.type !== 'HSPT' ? (
                        <div className={'filter-col'}>
                          <CustomDropDown
                            label="Difficulty"
                            name={'difficulty'}
                            onFilterChange={onFilterChange}
                            options={options2}
                            value={difficultyFilter}
                          />
                        </div>
                      ) : null}
                      <div className={'filter-col'}>
                        <CustomDropDown
                          label="Subscores/Cross-Test Scores"
                          name={'topic'}
                          options={topicsFilterOptions}
                          onFilterChange={onFilterChange}
                          value={topicsFilter}
                        />
                      </div>
                      <div className={'filter-col2'}>
                        <ButtonCTA
                          height="60px"
                          marginTop="25px"
                          width="100%"
                          label={'Clear all filters'}
                          onClick={onClearFilters}
                          purple
                        />
                      </div>
                    </div>
                    {quizResponse?.quiz?.type === 'SAT' ? (
                      <div className="tracker">
                        <h1>Assignment Tracker</h1>
                        <h3>
                          PROGRESS{' '}
                          {Math.ceil((assignmentTrackerReviewed / assignmentTrackerTotal) * 100)}%
                        </h3>
                        <div className="progressBar">
                          <ProgressBar
                            variant={
                              Math.ceil(
                                (assignmentTrackerReviewed / assignmentTrackerTotal) * 100,
                              ) >= 75
                                ? 'success'
                                : Math.ceil(
                                    (assignmentTrackerReviewed / assignmentTrackerTotal) * 100,
                                  ) >= 50
                                ? 'info'
                                : Math.ceil(
                                    (assignmentTrackerReviewed / assignmentTrackerTotal) * 100,
                                  ) >= 25
                                ? 'warning'
                                : 'danger'
                            }
                            now={Math.ceil(
                              (assignmentTrackerReviewed / assignmentTrackerTotal) * 100,
                            )}
                          />
                        </div>
                        <div className="question">
                          <p>SAT {selectedQuizSectionName}</p>
                          <p>
                            {assignmentTrackerReviewed} / {assignmentTrackerTotal}
                          </p>
                        </div>
                      </div>
                    ) : null}
                    <div style={{ padding: '0px' }} className="table-responsive dashboardTable">
                      {/* <ReactTable
                        columns={columns}
                        data={tableData}
                        pagination={false}
                      /> */}
                      <Table tableData={tableData} quizType={quizResponse?.quiz?.type} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </Container>
      <CustomFooter />
      
      {/* 悬浮提示：关于 review 按钮 */}
      {showReviewHint && shouldShowReviewFeatures() && (
        <div 
          className="review-hint-overlay"
          onClick={(e) => {
            if (e.target.classList.contains('review-hint-overlay')) {
              setShowReviewHint(false);
            }
          }}
        >
          <div className="review-hint-container">
            <button 
              className="review-hint-close"
              onClick={() => setShowReviewHint(false)}
              aria-label="Close"
            >
              ×
            </button>
            <div className="review-hint-content">
              <div className="review-hint-icon">💡</div>
              <div className="review-hint-text">
                <strong>Tip:</strong> Click the <span className="review-hint-button">Review</span> button below to start the
                <div className="review-hint-highlight">4-step review</div>
                for the corresponding question.
                <br />
                <br />
                If you need additional help, click the <span className="review-hint-button">Feeling stuck? Talk to an instructor!</span> button to schedule a consultation with an instructor.
              </div>
            </div>
            <div className="review-hint-actions">
              <button 
                className="review-hint-dismiss"
                onClick={() => {
                  localStorage.setItem('reviewHintDismissed', 'true');
                  setShowReviewHint(false);
                }}
              >
                Don't show again
              </button>
            </div>
          </div>
        </div>
      )}
    </WithNavBar>
  );
};

export default Dashboard;
